import "./homeLight.css"
export default function Home() {
 return (
    <div className="glavimg">
    <img src="/glav.svg" alt="Glav SVG" />
</div>
 )
}